import get from 'lodash.get';

import { selectUserSignup } from '../../../../redux/auth/signup/selectors';
import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

export const selectIsLoading = createDeepEqualSelector(selectUserSignup, (signup) => get(signup, 'loading', false));

export const selectError = createDeepEqualSelector(selectUserSignup, (signup) => get(signup, 'err', false));

export const selectErrorMessage = createDeepEqualSelector(selectUserSignup, (signup) => get(signup, 'errMsg', 'Error'));
